<template>
  <Carousel :autoplay="0" :pauseAutoplayOnHover="true" :mouseDrag="true"
    :items-to-show="numItemsToShowCarousel" :wrap-around="true" v-model="currentSlide"
    @update:modelValue="updateIframeColor">
    <Slide v-for="(game, index) in games" :key="index">
      <div>
        <div class="game-info-container" @mouseover="showInfo(index)" @mouseout="hideInfo" @click="slideTo(index)">
          
          <div style="position: relative">
            <img class="game-image" :src="getImage(game)">
          
            <div v-show="game.company">
              <img class="company-logo" :src="getCompanyImage(game.company)"
                   :style="{ backgroundColor: getBorderColor(game.company) }">
            </div>
          </div>
          <div class="game" :class="{ 'hovered': hoveredIndex === index }">
            <div class="overlay"></div>

            <div class="game-info">
              <div class="info-row">
                <p class="game-name">{{ game.gameName }}</p>
              </div>

              <div class="info-row">
                <p class="game-year">{{ game.releaseYear }}</p>
              </div>

              <div class="info-row">
                <p class="game-released">{{ game.releaseState }}</p>
              </div>

              <div class="info-row">
                <p class="company-name">{{ game.company }}</p>
              </div>

              <div class="info-row">
                <p class="role-name">{{ game.role }}</p>
              </div>

              <div class="icon-social-container">
                <a :href=game.playStoreLink target="_blank" v-if=game.playStoreLink>
                  <img class="icon__social" src="@/assets/navbar/play_store_icon.png" alt="Play Store">
                </a>

                <a :href=game.githubLink target="_blank" v-if=game.githubLink>
                  <img class="icon__social" src="@/assets/navbar/github_icon.png" alt="Github">
                </a>

                <a :href=game.linkedinLink target="_blank" v-if=game.linkedinLink>
                  <img class="icon__social" src="@/assets/navbar/linkedin_icon.png" alt="Icon">
                </a>

                <a :href=game.itchLink target="_blank" v-if=game.itchLink>
                  <img class="icon__social" src="@/assets/navbar/itch_icon.png" alt="itch.io">
                </a>

                <a :href=game.youtubeLink target="_blank" v-if=game.youtubeLink>
                  <img class="icon__social" src="@/assets/navbar/youtube_icon.png" alt="Youtube">
                </a>

                <a :href=game.siteLink target="_blank" v-if=game.siteLink>
                  <img class="icon__social" src="@/assets/navbar/website_icon.png" alt="Website">
                </a>

                <!-- Iframe location to Scroll -->
                <ScrollTo href="#gameIframe" offset="-450"
                  v-show="game.itchEmbedLink && currentScreenSize > game.itchWidth" class="playGameButton"
                  @click="clickToPlay(index)">

                  <span class="playGame-button">
                    <span class="download-text">{{ $t('games-carousel.play-now') }}</span>
                  </span>

                </ScrollTo>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Slide>

    <template #addons>
      <Navigation />
      <Pagination />
    </template>
  </Carousel>

  <div id="gameIframe">
    <div class="gameIframe" v-if="hasClickedToPlay" v-show="games[currentSlide].itchEmbedLink">
      <div class="gameIframeBG" id="iframeBG">
        <div class="game-name" style="text-shadow: #212121 -1px 1px 0px;">
          {{ games[currentSlide].gameName }}
        </div>

        <div class="close-btn" @click="closeIframe()">
          <span class="close-icon">
            ×
          </span>
        </div>

        <iframe frameborder="0" :src="games[currentSlide].itchEmbedLink" allowfullscreen=""
          :width="games[currentSlide]?.itchWidth" :height="games[currentSlide]?.itchHeight">
          <a :href="games[currentSlide].itchLink">Play {{ games[currentSlide].gameName }} on itch.io</a>
        </iframe>
      </div>
    </div>
  </div>
</template>

<script setup>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import ScrollTo from '@/components/Helpers/ScrollTo.vue';
import { defineProps, ref, onMounted, onUnmounted, nextTick } from "vue";

const props = defineProps({
  games: null,
});

const hoveredIndex = ref(0);
const numItemsToShowCarousel = ref(2.5);
const currentSlide = ref(0);
const hasClickedToPlay = ref(false);
const currentScreenSize = ref(0);
const autoPlayTime = ref(2000);

onMounted(() => {
  window.addEventListener("resize", handleResize());

  isMobile();
  hideInfo();
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize());
});

function handleResize() {
  checkWindowSize();
  isMobile();
}
function checkWindowSize() {
  currentScreenSize.value = screen.width;
}
function getImage(img) {
  return require(`@/assets/games/${img.gameBanner}.png`);
}
function getCompanyImage(companyName) {
  const companyImages = {
    "Virtual Planet": "virtual_planet",
    "Ludus Studios": "ludus_studios",
    "Brais Games": "brais_games",
    "Black Paladins": "black_paladins",
  };

  const imageName = companyImages[companyName] || "transparent";

  try {
    return require(`@/assets/about/${imageName}.png`);
  } catch (error) {
    return require("@/assets/about/transparent.png");
  }
}

function getBorderColor(companyName) {
  const colors = {
    "Virtual Planet": "black", 
    "Ludus Studios": "black", 
    "Brais Games": "#feb02a"  
  };

  return colors[companyName] || "#000000"; // Branco como padrão
}
function showInfo(index) {
  checkWindowSize();
  hoveredIndex.value = index;
}
function hideInfo() {
  hoveredIndex.value = null;
}
function isMobile() {
  if (screen.width > 1550 & screen.width <= 1800) {
    numItemsToShowCarousel.value = 2.5;
    return false;
  }
  else if (screen.width <= 1550 & screen.width > 1200) {
    numItemsToShowCarousel.value = 2;
    return false;
  }
  else if (screen.width > 850 & screen.width <= 1200) {
    numItemsToShowCarousel.value = 2.25;
    return true;
  }
  else if (screen.width > 650 & screen.width <= 850) {
    numItemsToShowCarousel.value = 1.75;
    return true;
  }
  else if (screen.width <= 650) {
    numItemsToShowCarousel.value = 1.25;
    return true;
  }
  else {
    numItemsToShowCarousel.value = 3;
    return false;
  }
}

function slideTo(val) {
  currentSlide.value = val

  updateIframeColor();
}

function clickToPlay(slideIndex) {

  if (slideIndex != currentSlide.value) {
    hasClickedToPlay.value = false;
  }

  hasClickedToPlay.value = !hasClickedToPlay.value;
  currentSlide.value = slideIndex;

  if (hasClickedToPlay.value) {
    autoPlayTime.value = 0;
  }
  else {
    autoPlayTime.value = 2000;
  }

  updateIframeColor();
}

function updateIframeColor(){

  if(props.games == null){
    return;
  }

  nextTick(() => {

    let hexColor = getColorHexFromURL(props.games[currentSlide.value].itchEmbedLink);
    
    let element = document.getElementById("iframeBG");

    if (element && hexColor) {
      element.style.backgroundColor = `#${hexColor}`;
    } 
  });
}

function getColorHexFromURL(url) {

  if(url == "") {
    return;
  }

  let urlObj = new URL(url);

  let colorHex = urlObj.searchParams.get('color');

  return colorHex;
}

function closeIframe() {
  hasClickedToPlay.value = false;
}
</script>

<style lang="scss" scoped>
@import '~/src/assets/css/GamesCarouselStyle.scss';

.company-logo {
  position: absolute; /* Para sobrepor a imagem do jogo */
  top: 0px;
  left: 0px;
  width: 50px;
  height: 50px;
  border: 3px solid white; /* Apenas a borda */
  border-radius: 20px; /* Opcional para bordas arredondadas */
  background-color: black;
}
.close-btn {
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 5px 10px;
  background-color: #ff4b4b;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  gap: 5px;
  /* Espaço entre o ícone e o texto */
  transition: background-color 0.3s ease;
  height: 40px;
  width: 40px;
  margin-bottom: -40px;
  justify-content: center;
  font-size: 38px;
}

.close-btn:hover {
  background-color: #ff1a1a;
}

.gameIframe {
  justify-content: center;
  display: flex;
  margin-top: 25px;
}

.gameIframeBG {
  position: relative;
  border-radius: 10px;
  text-align: center;
  color: #fff;
  /* Ajuste conforme necessário */
}

.playGameButton {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
  height: 50px;
}

.playGame-button {
  display: inline-flex;
  padding: 10px 20px;
  background-color: #4787FC;
  /* Cor de fundo do botão */
  color: white;
  /* Cor do texto do botão */
  text-decoration: none;
  border-radius: 20px;
  transition: background-color 0.3s ease;
  vertical-align: middle;
  cursor: pointer;
}

/* Estilo para o botão quando o mouse passa por cima */
.playGame-button:hover {
  background-color: #2e76fc;
  /* Cor de fundo alterada ao passar o mouse */
}

.download-text {
  font-family: 'Poppins-Bold';
  color: white;
  text-align: justify;
  margin-top: 3px;
}

@media (max-width: 1200px) {

  .playGame-button {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .playGameButton {
    height: 35px;
  }

  .download-text {
    margin-top: auto;
    margin-bottom: auto;
  }
}
</style>